import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Box, Flex, Spinner, Text } from '@chakra-ui/react';
import { Button } from '@/components/ui/Button';
import { CompanyForm } from '@/features/companies/components/CompanyForm';
import {
  companyQueries,
  useDeleteCompany,
  useUpdateCompany,
} from '@/features/companies/api/companyQueries';

export const Route = createFileRoute('/_authenticated/companies/$companyId')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(companyQueries.detail(params.companyId)),
  component: CompanyDetailPage,
});

function CompanyDetailPage() {
  const { companyId } = Route.useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useQuery(companyQueries.detail(companyId));
  const updateMutation = useUpdateCompany();
  const deleteMutation = useDeleteCompany();

  if (isLoading) {
    return (
      <Flex justify="center" py={8}>
        <Spinner />
      </Flex>
    );
  }

  const company = data?.item;

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={6}>
        <Text fontSize="2xl" fontWeight="bold">
          企業詳細
        </Text>
        <Button variant="outline" onClick={() => navigate({ to: '/companies' })}>
          一覧に戻る
        </Button>
      </Flex>

      <Box bg="bg.panel" p={6} borderRadius="md" shadow="sm">
        <CompanyForm
          initialValues={company ?? { id: companyId, name: '' }}
          onSubmit={async (values) => {
            await updateMutation.mutateAsync({ id: companyId, ...values });
          }}
          submitLabel="更新"
        />
        <Box mt={6} pt={4} borderTop="1px solid" borderColor="border.DEFAULT">
          <Button
            colorPalette="red"
            variant="outline"
            onClick={async () => {
              if (!confirm('この企業を削除してよろしいですか？')) return;
              await deleteMutation.mutateAsync(companyId);
              navigate({ to: '/companies' });
            }}
          >
            削除
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
